exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-module=ConsultWidget] .consult-bucket{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./medscape_modules/consult-widget/styles.scss
// module id = 630
// module chunks = 0